import http from "../../../utils/http-common";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import AdminGanttView from "../../GanttChart/AdminGanttChart";
import { setPlanForView } from "../../../Slices/planslice";
import { Back } from "../../../components/public/Button";

export const AdminViewPlan = () => {
  const location = useLocation();
  
  const searchParams = new URLSearchParams(location.search);
  const initialTab = location.state?.tab || "ganttchart";
  const [value, setValue] = useState(initialTab);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const urlid = searchParams.get("id");
  const [planId, setPlanId] = useState(
    () => localStorage.getItem("planId") || null
  );
  const userID = localStorage.getItem("user_id");
  useEffect(() => {
    fetchPlanDataparams(planId);
  }, [urlid]);
  const [planName, setPlanName] = useState("");
  const { id, isEdit, isView, isDelete, table, isShare } = useSelector(
    (state) => state.planslice
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [planData, setPlanData] = useState([]);
  const fetchPlanDataparams = async (planId) => {
    try {
      // Check URL expiration
      const searchParams = new URLSearchParams(location.search);
      const expiryTimestamp = searchParams.get("expires");

      const token = localStorage.getItem("token");
      const response = await http.get(`/master_service/get_plan/${planId}`, {
        headers: {
          Authorization: `${token}`,
        },
      });
      if (response.status === 200) {
        const data = response.data;
        //if (data.access_name === "full_access") {
          setPlanData(data);
          fetchJsonData(data);
          insertplan(data);
          setPlanId(urlid);

      }
    } catch (error) {
      if (error.response && error.response.status === 404) {

      } else {
        console.error("Error fetching user data", error);
      }
    }
  };
  const insertplan = async (data) => {
    try {
      const token = localStorage.getItem("token");
      const response = await http.post(
        `/master_service/view/plan/access/data`,
        {
          plan_id: data.plan_id,
          user_id: data.user_id,
        },
        {
          headers: {
            Authorization: `${token}`, // Pass the token in the Authorization header
          },
        }
      );
    } catch (error) {
      toast.error("Error inserting plan");
      console.error("Error fetching user data", error);
    }
  };
  const [jsonData, setJsonData] = useState([]);
  const fetchJsonData = async (data) => {
    try {
      const response = await http.post(`/master_service/store-plan-data`, {
        plan_id: data.plan_id,
      });
      if (response.status === 201 || 200) {
        const data = response.data;
        setJsonData(response.data.data.data.tasks);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };
  const handleNavigate = (path) => () => {
    navigate(path);

    if (isView) {
      dispatch(setPlanForView({ id: null, isView: false }));
    }
  };

  return (
    <div>
      <div
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "14.52px",
          textAlign: "left",
        }}>
        <span style={{ cursor: "pointer" }} onClick={handleNavigate(-1)}>
          Manage Plans
        </span>{" "}
        &gt; {planData?.plan_name}
      </div>
      <Back prop={{ txt: planData?.plan_name }} />
      <div sx={{ 
            marginTop: '15px',
            height: '86vh', // Adjust to account for header and tabs
            p: '4px',
            overflowX: 'auto'
        }}> 
            <AdminGanttView projectData={jsonData} />
      </div>
    </div>
  );
};
